import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { url_249 } from "../../../../../../../../custom_utilities/api_services";
import useAuthUtils from "../../../../../../../../hooks/auth/useAuthUtils";

const useDeleteProductFromCart = () => {
  const queryClient = useQueryClient();
  const { headers, startLoading, finishLoading } = useAuthUtils();

  const deleteProductFromCart = async (productId) => {
    try {
      startLoading();

      const response = await axios.post(
        url_249,
        { product_id: productId },
        headers
      );

      console.log("response.data", response.data.data);
      finishLoading();

      return response.data.data;
    } catch (err) {
      finishLoading();

      console.log(err.message);
    }
  };

  const { mutate, isSuccess } = useMutation({
    mutationKey: ["delete_product_from_cart"],
    mutationFn: ({ productId, token, tokenType }) =>
      deleteProductFromCart(productId, token, tokenType),

    onSuccess: () => {
      queryClient.invalidateQueries(["cart_products"]);
    },
  });

  return { mutate, isSuccess };
};

export default useDeleteProductFromCart;
